import "../css/backdrop.css";

const BackDrop = ({ children, on = true }) => {
  return <div className={on ? "backdrop" : ""}>{children}</div>;
};

export default BackDrop;
